import { render, staticRenderFns } from "./stakeholder.vue?vue&type=template&id=a5fed046"
import script from "./stakeholder.vue?vue&type=script&lang=js"
export * from "./stakeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5fed046')) {
      api.createRecord('a5fed046', component.options)
    } else {
      api.reload('a5fed046', component.options)
    }
    module.hot.accept("./stakeholder.vue?vue&type=template&id=a5fed046", function () {
      api.rerender('a5fed046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/stakeholder.vue"
export default component.exports